
import Blog from '~/components/Common/Blog'
import Content from '~/components/Common/Blog/BlogContent/Text3SectionType'
// import { EventBus } from '~/components/Common/eventBus'

export default {
    name: 'BlogTextColor',
    components: { Blog, Content },
    props: {
        newsType: String,
        pageTitle: String,
        renderMock: {
            type: Boolean,
            default: false,
        },
    },
}
